import { Role } from "@soft-db/monitoring-api-client";

export function useRoleLabel() {
	const { t } = useI18n();

	return (role: Role) => {
		switch (role) {
			case "sys_admin":
				return t("role.sys_admin");

			case "admin":
				return t("role.admin");

			case "editor":
				return t("role.editor");

			case "viewer":
				return t("role.viewer");
		}
	};
}
